import React, { Component } from "react";
import config from "./../../common/config";
import core from "./../../common/core";
import Popup from "./../../componentsReusable/popup";
import Trans from "./../../componentsReusable/trans";
let setTimeoutObj = null;
class PopupAlert extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  onClickHide = () => {
    clearTimeout(setTimeoutObj);
    this.showHideAlert();
  };
  showHideAlert = () => {
    this.props.showHideAlert && this.props.showHideAlert(false, "", "", "");
  };
  render() {
    let self = this;
    const { onClickHide, props } = self;
    let { titleText, bodyText, sClass } = props;
    const eventClickHide = { onClick: onClickHide };
    return (
      <div
        className={"m11c-toast__wrap m11c-toast__wrap--topAppear " + sClass}
        {...eventClickHide}
      >
        {/* <!-- m11c-success | m11c-danger --> */}
        <div className="m11c-toast__title">
          {sClass == "m11c-show m11c-danger" ? (
            <i className="m11ci-alert" />
          ) : (
            <i className="m11ci-alert" />
          )}
          <span>{titleText}</span>
        </div>
        <div className="m11c-toast__text">
          <span>{bodyText}</span>
        </div>
      </div>
    );
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    let self = this;
    const {
      titleText: titleTextOld,
      bodyText: bodyTextOld,
      sClass: sClassOld,
    } = this.props;
    let { titleText, bodyText, sClass } = nextProps;
    const sOld =
      (titleTextOld ? titleTextOld.toString() : "0") +
      (bodyTextOld ? bodyTextOld.toString() : "0") +
      (sClassOld ? sClassOld.toString() : "0");
    const sNew =
      (titleText ? titleText.toString() : "0") +
      (bodyText ? bodyText.toString() : "0") +
      (sClass ? sClass.toString() : "0");
    if (sOld !== sNew) {
      clearTimeout(setTimeoutObj);
      if (nextProps.isShow) {
        setTimeoutObj = setTimeout(function () {
          self.showHideAlert();
        }, config.timeoutForToast);
      }
    }
  }

  componentDidMount() {
    let self = this;
    clearTimeout(setTimeoutObj);
    if (self.props.isShow) {
      setTimeoutObj = setTimeout(function () {
        self.showHideAlert();
      }, config.timeoutForToast);
    }
  }

  componentWillUnmount() {
    let self = this;
    clearTimeout(setTimeoutObj);
    self.showHideAlert();
  }
}
export default PopupAlert;
